import type { ComponentType } from 'react';
import {
	Wifi,
	Car,
	Users,
	Coffee,
	Bath,
	Wind,
	Accessibility,
	Heart,
	Sun,
	CreditCard,
	Zap,
	Armchair,
} from 'lucide-react';

export interface TFacilityDefinition {
	id: string;
	label: string;
	icon: ComponentType<{ className?: string }>;
}

export const ALL_FACILITIES: TFacilityDefinition[] = [
	{ id: 'wifi', label: 'Wi-Fi', icon: Wifi },
	{ id: 'parking', label: 'Parking', icon: Car },
	{ id: 'meeting-room', label: 'Meeting Room', icon: Users },
	{ id: 'refreshments', label: 'Refreshments', icon: Coffee },
	{ id: 'restrooms', label: 'Restrooms', icon: Bath },
	{ id: 'ac', label: 'Air Conditioning', icon: Wind },
	{ id: 'accessible', label: 'Wheelchair Accessible', icon: Accessibility },
	{ id: 'pet-friendly', label: 'Pet Friendly', icon: Heart },
	{ id: 'outdoor-seating', label: 'Outdoor Seating', icon: Sun },
	{ id: 'pos', label: 'Card / POS Payment', icon: CreditCard },
	{ id: 'ev-charging', label: 'EV Charging', icon: Zap },
	{ id: 'lounge', label: 'Waiting Lounge', icon: Armchair },
];

export const FACILITIES_BY_ID = Object.fromEntries(ALL_FACILITIES.map((item) => [item.id, item]));
